import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectResult } from 'services/results/selectors';

// Global Components
// @ts-ignorec
import ResponsiveTable from 'components/ResponsiveTable';
// @ts-ignore
import TableCountDropdown from 'components/TableCountDropdown';

// Child Components
// @ts-ignore
import TimesheetEntriesPagination from '../TimesheetEntriesPagination';
import TimesheetEntriesTableHead from './components/TimesheetEntriesTableHead';
// @ts-ignore
import TimesheetEntriesTableRow from './components/TimesheetEntriesTableRow';

interface ConnectedProps {
    uuids?: string[] 
}

type Props = ConnectedProps;

export class TimesheetEntriesTable extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { uuids } = this.props;
        return (
            <React.Fragment>
                <ResponsiveTable>
                    <Table
                        sortable
                        striped
                        singleLine
                        unstackable
                        size="small"
                        selectable
                    >
                        <TimesheetEntriesTableHead />
                        <Table.Body>
                            {(!uuids || !uuids.length) && (
                                <Table.Row colSpan="17" textAlign="center">
                                    <Table.Cell
                                        colSpan="17"
                                        className="events-table-cell-padding"
                                    >
                                        There are no Timesheet Entries.
                                    </Table.Cell>
                                </Table.Row>
                            )}
                            {uuids &&
                                uuids.map(uuid => (
                                    <TimesheetEntriesTableRow
                                        key={uuid}
                                        timesheetEntryUuid={uuid}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginLeft: 'auto' }}>
                        <TableCountDropdown defaultCount={25} />
                        <TimesheetEntriesPagination />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    {},
    ConnectedProps
>({
    uuids: makeSelectResult('TIMESHEET_ENTRIES_LOAD')
});

export default connect(mapStateToProps)(TimesheetEntriesTable);
